import {
  IdentityVerifyResponse,
  Channel,
  IdentityPassportResponse,
  IdentityPassportRequest,
  IdentityPassportCountriesResponse,
  IdentityMedicareResponse,
  IdentityMedicareRequest,
  IdentityLicenseResponse,
  IdentityLicenseRequest,
  IdentityVerifyRequest,
  IdentityNationalIDNumberResponse,
  IdentityNationalIDNumberRequest,
} from '../types'

import { apiService } from '../../'

export const identityService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    identityVerify: build.mutation<IdentityVerifyResponse, IdentityVerifyRequest>({
      query: ({ channel = Channel.PORTAL }) => ({
        url: '/portal/consumers/identities/verify',
        method: 'post',
        data: {
          channel,
        },
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    identityNationalIDNumberDeprecated: build.mutation<IdentityNationalIDNumberResponse, IdentityNationalIDNumberRequest>({
      query: (body) => ({
        url: '/portal/consumers/identities/national-id-number',
        method: 'post',
        data: body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    identityPassport: build.mutation<IdentityPassportResponse, IdentityPassportRequest>({
      query: (body) => ({
        url: '/portal/consumers/identities/passport',
        method: 'post',
        data: body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    identityPassportCountries: build.query<IdentityPassportCountriesResponse, void>({
      query: () => ({
        url: '/portal/consumers/identities/passport/countries',
        method: 'get',
      }),
    }),
    identityMedicare: build.mutation<IdentityMedicareResponse, IdentityMedicareRequest>({
      query: (body) => ({
        url: '/portal/consumers/identities/medicare',
        method: 'post',
        data: body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
    identityLicense: build.mutation<IdentityLicenseResponse, IdentityLicenseRequest>({
      query: (body) => ({
        url: '/portal/consumers/identities/drivers-licence',
        method: 'post',
        data: body,
      }),
      invalidatesTags: ['ConsumerAccount'],
    }),
  }),
})
